import React, { useState } from 'react'
import {
  Button,
  useErrorService,
  useNotificationService,
} from '@abroad/components'
import { AssignCoachPairingModal } from '../common'
import AssignSOWSection from '../OrgEco/AssignSOWSection'
import API from '../../utils/API'

const GroupCoachPairingButton = ({ teamId, disabled = false, className }) => {
  const [isFetching, setIsFetching] = useState(false)
  const [groupMembers, setGroupMembers] = useState([])
  const [groupCoachIds, setGroupCoachIds] = useState([])
  const [showCoachModal, setShowCoachModal] = useState(false)
  const [showSOWModal, setShowSOWModal] = useState(false)
  const [userCoachAssignments, setUserCoachAssignments] = useState([])
  const [pairingCoaches, setPairingCoaches] = useState([])
  const [pairingSchedulingMeta, setPairingSchedulingMeta] = useState(null)
  const [flowKey, setFlowKey] = useState(0)
  const ErrorService = useErrorService()
  const Notification = useNotificationService()

  const resetFlow = () => {
    setShowCoachModal(false)
    setShowSOWModal(false)
    setUserCoachAssignments([])
    setPairingCoaches([])
    setPairingSchedulingMeta(null)
    setFlowKey((prev) => prev + 1)
  }

  const openCoachPairing = async () => {
    setIsFetching(true)
    try {
      const { data } = await API.AdminAPI.teams.getTeamData(teamId)
      const members = data?.members?.filter((member) => member?._id) || []
      const coachIds =
        data?.coaches?.map((coach) => coach?._id).filter(Boolean) || []

      if (members.length === 0) {
        Notification.showNotification(
          'Please add members to this group before coach pairing.',
        )
        return
      }
      if (coachIds.length === 0) {
        Notification.showNotification(
          'Please add coaches to this group before coach pairing.',
        )
        return
      }

      setGroupMembers(members)
      setGroupCoachIds(coachIds)
      setShowCoachModal(true)
    } catch (e) {
      ErrorService.showError(e)
    } finally {
      setIsFetching(false)
    }
  }

  const handleAssignCoach = (
    coach,
    coaches,
    assignments = [],
    schedulingMeta = null,
  ) => {
    if (!Array.isArray(assignments) || assignments.length === 0) return

    setUserCoachAssignments(
      assignments.map(({ userId, coachId }) => ({
        clientId: userId,
        coachId,
      })),
    )
    setPairingCoaches(coaches || [])
    setPairingSchedulingMeta(schedulingMeta)
    setShowCoachModal(false)
    setShowSOWModal(true)
  }

  const handleSuccess = () => {
    Notification.showNotification(
      'Coach pairing completed and SOWs have been created!',
      'success',
    )
    resetFlow()
  }

  return (
    <>
      <Button
        variant='saffron'
        size='md'
        className={className || 'line-height-normal assign-btn ml-2 px-3'}
        style={{ height: '2rem' }}
        onClick={openCoachPairing}
        isLoading={isFetching}
        disabled={disabled || isFetching}
        title={
          disabled
            ? 'Please save group changes before coach pairing.'
            : undefined
        }>
        Coach Pairing
      </Button>
      <React.Fragment key={flowKey}>
        <div className='d-none'>
          <AssignSOWSection
            showModal={showSOWModal}
            setShowModal={setShowSOWModal}
            usersHasOneCoach={true}
            userCoachMapping={userCoachAssignments}
            pairingCoaches={pairingCoaches}
            pairingSchedulingMeta={pairingSchedulingMeta}
            showCoachModal={showCoachModal}
            setShowCoachModal={setShowCoachModal}
            onResetAndRefresh={resetFlow}
            onSuccess={handleSuccess}
          />
        </div>
        <AssignCoachPairingModal
          handleAssignCoach={handleAssignCoach}
          isSubmitting={false}
          showModal={showCoachModal}
          setShowModal={setShowCoachModal}
          selectedUsers={groupMembers}
          allowedCoachIds={groupCoachIds}
          onResetAndRefresh={resetFlow}
        />
      </React.Fragment>
    </>
  )
}

export default GroupCoachPairingButton
